import { apiHelper } from '@/utils';
import { API } from '@/constants';

const API_URL = `${API.BASE_URL_API}/v1`;

export const articleCategoryService = { getAll, store, show, update, softDelete };

export function getAll(filter = {}) {
    const params = {
        page: filter.pageNumber,
        size: filter.pageSize,
        sortBy: filter.sortBy,
        orderBy: filter.orderBy,
    };
    const searchWords = (filter.searchArray || []).filter((word) => word != null && word !== '');
    if (searchWords.length) params.search_words = searchWords;
    return apiHelper(API_URL).get('/article-categories', { params });
}

export function store(data) {
    return apiHelper(API_URL).post('/article-categories', { name: data.name });
}

export function show(uuid) {
    return apiHelper(API_URL).get(`/article-categories/${uuid}`);
}

export function update(data) {
    return apiHelper(API_URL).put(`/article-categories/${data.uuid}`, { name: data.name });
}

export function softDelete(uuid) {
    return apiHelper(API_URL).patch(`/article-categories/delete/${uuid}`);
}
